import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useBilling } from "../../../../context/BillingContext";

export const ConfirmationModal = ({
  modalData,
  setModalData,
  handleCancelConfirm,
  handlePaymentSuccessNavigation,
  failedNavigationUrl,
}) => {
  const [cancelLoading, setCancelLoading] = useState(false);
  const { isThemeModal } = useBilling();
  const location = useLocation();
  const currentUrl = location.pathname;

  // Add inside the component, at the top level
  useEffect(() => {
    if (modalData.open) {
      document.body.classList.add("modal-open-blur");
    } else {
      document.body.classList.remove("modal-open-blur");
    }
    return () => {
      document.body.classList.remove("modal-open-blur");
    };
  }, [modalData.open]);

  const getTitle = () => {
    switch (modalData.type) {
      case "success":
        return "Payment Successful";

      case "failed":
        return "Payment Failed";

      case "confirm-cancel":
        return "Confirm Cancellation";

      case "cancelled":
        return "Payment Cancelled";

      default:
        return "Session Expired";
    }
  };
  const renderIcon = () => {
    if (modalData.type === "success") {
      return (
        <div className="cancel-modal-icon-ring success">
          <i className="bi bi-check2 cancel-modal-status-icon success"></i>
        </div>
      );
    }

    if (modalData.type === "failed") {
      return (
        <div className="cancel-modal-icon-ring failed">
          <i className="bi bi-x-lg cancel-modal-status-icon failed"></i>
        </div>
      );
    }

    if (modalData.type === "confirm-cancel") {
      return (
        <div className="cancel-modal-icon-ring warning">
          <svg
            className="cancel-modal-icon"
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 9V13"
              stroke="#D16BFF"
              strokeWidth="2.2"
              strokeLinecap="round"
            />
            <circle cx="12" cy="17" r="1" fill="#D16BFF" />

            <path
              d="M10.29 3.86002L1.82004 18C1.64539 18.3024 1.55296 18.6453 1.552 18.9945C1.55104 19.3438 1.64158 19.6872 1.81456 19.9905C1.98754 20.2939 2.23691 20.5464 2.53805 20.7232C2.8392 20.9 3.18159 20.9949 3.53104 20.998H20.469C20.8184 20.9949 21.1608 20.9 21.462 20.7232C21.7631 20.5464 22.0125 20.2939 22.1855 19.9905C22.3585 19.6872 22.449 19.3438 22.4481 18.9945C22.4471 18.6453 22.3547 18.3024 22.18 18L13.71 3.86002C13.5325 3.56611 13.2822 3.32288 12.9833 3.15387C12.6844 2.98486 12.347 2.89575 12.0035 2.89526C11.66 2.89476 11.3224 2.98289 11.023 3.15103C10.7236 3.31918 10.4726 3.56169 10.294 3.85502L10.29 3.86002Z"
              stroke="#D16BFF"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      );
    }

    return (
      <div className="cancel-modal-icon-ring expired">
        <i className="bi bi-clock-history cancel-modal-status-icon expired"></i>
      </div>
    );
  };

  return (
    <div className="cancel-modal-overlay">
      <div
        className={`cancel-modal-container ${!isThemeModal ? "modal-force-dark" : ""}`}
      >
        {/* Glow */}
        <div className="cancel-modal-glow"></div>

        {/* Icon */}
        <div className="cancel-modal-icon-wrapper">{renderIcon()}</div>

        {/* Title */}
        <h2 className="cancel-modal-title">{getTitle()}</h2>

        {/* Description */}
        <p className="cancel-modal-description">{modalData.message}</p>

        {/* Actions */}
        {modalData.type === "confirm-cancel" ? (
          <div className="cancel-modal-actions">
            <button
              className="cancel-modal-btn secondary"
              onClick={() =>
                setModalData({
                  open: false,
                  type: "",
                  message: "",
                })
              }
              disabled={cancelLoading}
            >
              Keep Plan
            </button>

            <button
              className="cancel-modal-btn primary"
              disabled={cancelLoading}
              onClick={async () => {
                setCancelLoading(true);
                await handleCancelConfirm();
                setCancelLoading(false);
              }}
            >
              {cancelLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Cancelling...
                </>
              ) : (
                "Yes, Cancel"
              )}
            </button>
          </div>
        ) : modalData.type === "success" || modalData.type === "cancelled" ? (
          <button
            className="cancel-modal-btn full primary"
            onClick={handlePaymentSuccessNavigation}
          >
            Continue
          </button>
        ) : (
          <button
            className="cancel-modal-btn full secondary"
            onClick={() =>
              setModalData({
                open: false,
                type: "",
                message: "",
              })
            }
          >
            Close
          </button>
        )}
      </div>
    </div>
  );
};
